import { css } from 'styled-components';
import { mapToBreakpoints } from '../../../mixins/mapToBreakpoints.js';
import { spaceProp } from '../../../mixins/spaceProp.js';
import { ListItemBaseLi } from '../ListItemBase.js';

const justifyContentMap = {
  stretch: 'space-between',
  center: 'center',
  start: 'flex-start',
  end: 'flex-end'
};
const alignItemsMap = {
  stretch: 'flex-start',
  center: 'center',
  start: 'flex-start',
  end: 'flex-end'
};
const getListVariantStyles = (values, spaceBetween, isBordered) => ({
  theme
}) => {
  const bordersHorizontal = isBordered && css(["> ", "{border-top:none;border-bottom:none;border-left:none;border-right:1px solid ", ";&:first-child{border-top:none;border-bottom:none;border-right:1px solid ", ";border-left:1px solid ", ";}}"], ListItemBaseLi, theme.components.divider.color, theme.components.divider.color, theme.components.divider.color);
  const bordersVertical = isBordered && css(["> ", "{border-right:none;border-top:none;border-left:none;border-bottom:1px solid ", ";&:first-child{border-right:none;border-left:none;border-bottom:1px solid ", ";border-top:1px solid ", ";}}"], ListItemBaseLi, theme.components.divider.color, theme.components.divider.color, theme.components.divider.color);
  return mapToBreakpoints(values, value => {
    const [, position] = value.split('-');
    switch (value) {
      case 'horizontal-start':
      case 'horizontal-end':
      case 'horizontal-center':
      case 'horizontal-stretch':
        return css(["flex-direction:row;justify-content:", ";align-items:initial;", ";", "{margin-bottom:0;margin-right:", ";", " width:", ";}"], justifyContentMap[position], bordersHorizontal, ListItemBaseLi, theme.components.listItem.spaceBetween, spaceProp(spaceBetween, 'margin-right'), position === 'stretch' ? '100%' : 'auto');
      case 'vertical-start':
      case 'vertical-end':
      case 'vertical-center':
      case 'vertical-stretch':
        return css(["flex-direction:column;align-items:", ";justify-content:initial;", ";", "{margin-right:0;margin-bottom:", ";", " width:", ";}"], alignItemsMap[position], bordersVertical, ListItemBaseLi, theme.components.listItem.spaceBetween, spaceProp(spaceBetween, 'margin-bottom'), position === 'stretch' ? '100%' : 'auto');
    }
  });
};

export { getListVariantStyles };
//# sourceMappingURL=getListVariantStyles.js.map
